module.exports = __webpack_public_path__ + "static/media/majorG2.272159d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorG2.wav
// module id = HyAv
// module chunks = 0